import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import {_,moment} from '../../../js/globals';
import { ClientLoggerService } from '../../services/client-logger.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MySynchDataStore } from '../../data-stores/mysynch.datastore';
import { MySynchConstantService } from '../../services/mysynch.constant.service';
import { PerformanceContextService } from '../../services/performance-context.service';
import { PerformanceContext} from '../../interfaces/mysynch.interfaces';
import FileSaver from 'file-saver';

// interfaces
import { ViewableSpecialReport,DownloadableSpecialReport,SpecialReport } from './special-reports.interfaces';
import { PerformanceMetricsService } from '../../services/performance-metrics.service';

@Component({
    standalone: false,
    selector: 'special-reports',
    templateUrl: '../app/pages/special-reports/special-reports.view.html',
    styleUrls: ['../app/pages/special-reports/special-reports.style.css']
    })
export class SpecialReports implements OnInit, OnDestroy {

    private performanceContext: PerformanceContext | null = null;
    private currentHerd:any;
    private reportDescriptions:any;
    private downloadableReportFilenameSplitter:string = "_downloadable-rpt_";
    

    // subscriptions and deregistrations
    private deregCurrentActiveHerd:any;

    _:any;
    isMobile:boolean = this.deviceDetector.isMobile();

    loading:boolean = true;
    currentHerdId:number = 0;
    currentHerdKey:string = "";
    isDemoUser:boolean = false;
    
    viewableReports:ViewableSpecialReport[] = [];
    downloadableReports:DownloadableSpecialReport[] = [];
    
    
   constructor(@Inject('MySynchFactory') private MSF:any,
   @Inject('ApiFactory') private api:any,
   @Inject(DeviceDetectorService) private deviceDetector:DeviceDetectorService,
   @Inject(MySynchDataStore) private mysynchDataStore:MySynchDataStore,
   @Inject(MySynchConstantService) private mySynchConstantService:MySynchConstantService,
   @Inject(PerformanceMetricsService) private perfMetricSvc:any,
   @Inject(PerformanceContextService) private perfContextSvc:PerformanceContextService,
   @Inject(ClientLoggerService) private log:ClientLoggerService
   ){
       this._ = _;

   }

   private getDownloadableReportDisplayName(reportBlobPath:string){
        let reportName = "";

        if(_.includes(reportBlobPath, this.downloadableReportFilenameSplitter)){
            let blobPathParts = reportBlobPath.split(this.downloadableReportFilenameSplitter);
            reportName = _.last(blobPathParts); // replace underscores with spaces for display
        }
        return reportName; 
    }
    

   private buildViewableSpecialReports(viewableReportsData:any){
       var viewableReports:ViewableSpecialReport[] = [];
       if(!this._.isEmpty(viewableReportsData)){
          this._.forEach(viewableReportsData, (report:any) => {
              var reportNameDisplay = this._.get(report,'reportName','').replace(/_/g,' '); // replace underscores with spaces for display
              var reportNameForUrl = this._.get(report,'shinyUrl','');
              
              var url = this.mySynchConstantService.specialReportsShinyURLPrefix + reportNameForUrl;

                var viewableReport:ViewableSpecialReport = {
                    id: this._.get(report,'id'),
                    reportName: reportNameDisplay,
                    description: this._.get(report,'description'),
                    url: url
                };
                viewableReports.push(viewableReport);
          });
       }
       return viewableReports;
   }

   private buildDownloadableSpecialReports(downloadableReportsData:any){
       var downloadableReports:DownloadableSpecialReport[] = [];
       
       if(!this._.isEmpty(downloadableReportsData)){
            this._.forEach(downloadableReportsData, (reportBlobItem:any) => {
                var reportName = this._.get(reportBlobItem,'reportName','');
                var reportDisplayName = this.getDownloadableReportDisplayName(reportName);
                var description =  _.get(reportBlobItem,'description',"");
                    var downloadableReport:DownloadableSpecialReport = {
                        reportName: reportDisplayName,
                        description: description,
                        blobPath: reportName
                    };
                    downloadableReports.push(downloadableReport);
            });
         }
         return downloadableReports;
   }

   private loadSpecialReports(){
        return new Promise((resolve, reject) => {
            var herdId = this._.get(this.currentHerd,'herdId'); 
            var herdKey = this._.get(this.currentHerd,'herdKey');

            this.perfMetricSvc.startTiming('Page:SpecialReportsPageData:Request');
            this.api.getHerdSpecialReports(herdId,herdKey, this.performanceContext, (err, results) => {
                this.perfMetricSvc.endTiming("page",'Page:SpecialReportsPageData:Request', this.performanceContext);
                if(err){
                    this.log.error('Error getting special reports: ' + err);
                }

                this.perfMetricSvc.startTiming('Page:SpecialReports:Build');
                if(results){

                    this.viewableReports = this.buildViewableSpecialReports(_.get(results,'viewableReports',[]));
                    this.downloadableReports = this.buildDownloadableSpecialReports(_.get(results,'downloadableReports',[]));
                }
                this.perfMetricSvc.endTiming("page",'Page:SpecialReports:Build', this.performanceContext);
                this.loading = false;
                resolve(true);
            });
        });

    }

   downloadSpecialReport(reportBlobPath:string){
         console.log("downloading report",reportBlobPath);
          this.perfMetricSvc.startTiming('Page:SpecialReportsPageData:DownloadRequest');
         this.api.downloadSpecialReport(reportBlobPath, this.performanceContext, (err, response) => {
            this.perfMetricSvc.endTiming("page",'Page:SpecialReportsPageData:DownloadRequest', this.performanceContext);
            if(err){
                this.log.error('Error downloading special report: ' + err);
            }
            if(response && !this._.isUndefined(this._.get(response,'headers'))){
                var reportBlobData = this._.get(response,'data');
                var blob = new Blob([reportBlobData], { type: response.headers('content-type') });
                const downloadFilename = _.last(reportBlobPath.split(this.downloadableReportFilenameSplitter));
                FileSaver.saveAs(blob, downloadFilename);
            }else{
                this.log.error('Error downloading special report - no results or no headers: ' + err);
            }
         });
   }


   ngOnDestroy() {
        // unsubscribe from the current active herd observable  
        if(this.deregCurrentActiveHerd){
            this.deregCurrentActiveHerd.unsubscribe();
        }
        this.performanceContext
    }
   

   ngOnInit() {
        this.MSF.ready(()=> {

            this.currentHerd = this.MSF.getActiveHerd();
            this.currentHerdId = this._.get(this.currentHerd,'herdId');
            this.currentHerdKey = this._.get(this.currentHerd,'herdKey');  
            this.isDemoUser = this.MSF.currentUserIsDemoUser();      

            this.reportDescriptions = this._.filter(_.get(this.MSF,'lists.codeFile',[]),{codeType: this.mySynchConstantService.specialReportDescriptionsCodeType});

            this.performanceContext = this.perfContextSvc.createPerformanceContext(this.currentHerdId);
            this.perfMetricSvc.startTiming('Page:SpecialReports:Render');
            this.loadSpecialReports().then((result) => {
                this.perfMetricSvc.markPageReady('Page:SpecialReports:Render', this.performanceContext);
            });

           this.deregCurrentActiveHerd = this.mysynchDataStore.currentActiveHerd
            .subscribe((herd:any)=>{
               if(!this.MSF.isNullish(herd) && !this.loading ){
                    this.loading = true;
                    this.currentHerd = herd;
                    this.currentHerdId = this._.get(this.currentHerd,'herdId');
                    this.currentHerdKey = this._.get(this.currentHerd,'herdKey');

                    this.performanceContext = this.perfContextSvc.createPerformanceContext(this.currentHerdId);
                    this.perfMetricSvc.startTiming('Page:SpecialReports:RenderOnHerdChange');
                    this.loadSpecialReports().then((result) => {
                        this.perfMetricSvc.markPageReady('Page:SpecialReports:RenderOnHerdChange', this.performanceContext);
                    });
                }
            });


        });
   }

}